import { Api } from '../axios-config'
import { IIndice } from '../indice/IndiceService';

export interface ICaixa {
    idCaixa: number,
    idTipoCaixa: number,
    localizador?: string,
    codigoBarras?: string,
    qtdeEtiquetas?: number,
}

export interface ISetor_Caixa {
    idSetor: number,
    nomeSetor: string,
}

export interface ICaixa_Tipo {
    idTipo: number,
    nomeTipo: string,
    hierarquia: string,
}

export interface IIndice_caixa {
    idIndice_caixa?: number,
    idIndice: number,
    idCaixa: number,
    valor: string | null,
    dataInicial: string | null,
    dataFinal: string | null,
}

export interface IAlterarIndice_Caixa extends IIndice_caixa {
    indice: IIndice;
}

const create = async (dados: Omit<ICaixa, 'idCaixa'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post('Caixa', dados);

        if (data) {
            return data.idCaixa;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
}

const createSetores = async (dados: { idSetor: number, idCaixa: number }[]) => {
    try {
        const { data } = await Api.post('Setor_caixa', dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
}

const createTipos = async (dados: { idTipo: number, idCaixa: number }[]) => {
    try {
        const { data } = await Api.post('Caixa_tipo', dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
}

const getByIdCaixa = async (idCaixa: number): Promise<ICaixa | Error> => {
    try {

        const { data } = await Api.get(`Caixa/id?id=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getIdUnidadeByIdCaixa = async (idCaixa: number): Promise<number | Error> => {
    try {

        const { data } = await Api.get(`Setor_caixa/pesquisar/SetoresPorCaixa?idCaixaStr=${idCaixa}`);;

        if (data) {
            let idUnidade = data[0].idUnidade;
            return idUnidade;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getSetoresByIdCaixa = async (idCaixa: number): Promise<ISetor_Caixa[] | Error> => {
    try {

        const { data } = await Api.get(`Setor_caixa/pesquisar/SetoresPorCaixa?idCaixaStr=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const updateById = async (dados: ICaixa): Promise<void | Error> => {
    try {
        await Api.put(`Caixa`, dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const createIndice_caixa = async (dados: IIndice_caixa[]): Promise<IIndice_caixa | Error> => {
    try {
        const { data } = await Api.post(`Indice_caixa`, dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
}

const getIndicesByIdCaixa = async (idCaixa: number): Promise<IAlterarIndice_Caixa[] | Error> => {
    try {

        const { data } = await Api.get(`Indice_caixa/porIdCaixa?idCaixa=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const importarLocalizadores = async (file: FormData): Promise<void | Error> => {
    try {
        await Api.post(`Caixa/importarLocalizadores`, file, { headers: { 'Content-Type': 'multipart/form-data' } });
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao importar localizadores');
    }
}

export const Detalhe_Caixa_Service = {
    create,
    createSetores,
    createTipos,
    getByIdCaixa,
    getIdUnidadeByIdCaixa,
    getSetoresByIdCaixa,
    updateById,
    createIndice_caixa,
    getIndicesByIdCaixa,
    importarLocalizadores,
}